import BaseResource from './BaseResource'

export default class Explorecards extends BaseResource<any> {
  endpoint = 'v1/explorecards'
}
